//HOOKS
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import useSnackbarNotification from "../hooks/useSnackbarNotification";

//ICONS
import { FaRedo } from "react-icons/fa";

import confirmImg from "../assets/Check your inbox.svg";

const ConfirmEmailPage = () => {
    const navigate = useNavigate();
    const { resendAuthEmail } = useAuth();
    const { showError, showSuccess } = useSnackbarNotification();

    const handleResendEmail = async () => {
        //get email from localStorage
        const email = localStorage.getItem('signupEmail');
        if (!email) {
            showError("No email found to resend verification.");
            return;
        }

        try {
            const { data, error } = await resendAuthEmail(email);
            console.log("Resend email data:", data);
            showSuccess("Email resent successfully:");
            localStorage.removeItem('signupEmail');
            navigate('/login');
        } catch (error) {
            console.error("Resend email error:", error);
            showError("Error resending email:", error);
        }


    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-2xl md:max-w-5xl">
                <div className="bg-white py-4 px-10 shadow-sm sm:rounded-lg">
                    {/* heading */}
                    <h1 className="text-[20px] md:text-[30px] lg:text-[30px] xl:text-[30px] font-bold text-center">Create an account</h1>

                    {/* center image */}
                    <div className="flex justify-center my-6">
                        <img src={confirmImg} alt="Check your inbox" />
                    </div>

                    {/* verify text and button */}
                    <p className="text-center font-bold text-[22px] md:text-[32px] lg:text-[32px] xl:text-[32px]">
                        Verify Your Email Address To Get Started
                    </p>
                    <p className="mt-4 text-center max-w-xl mx-auto text-[14px] md:text-[16px] lg:text-[16px] xl:text-[16px]">
                        Check your inbox (or spam folder) for the verification email or resend it.
                        If you’re not receiving it, please contact our <span className="underline"
                            onClick={() => {
                                window.open("https://tally.so/r/wb6krg", "_blank");
                            }}>support team</span> for assistance.
                    </p>
                    <div className="mt-6 flex justify-center">
                        <button className="bg-black text-white py-2 px-4 rounded-full flex items-center hover:scale-110"
                            onClick={handleResendEmail}>
                            <FaRedo className="inline mr-2" size={14} />
                            Resend Email
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmEmailPage;
